function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import { Input } from "bitshares-ui-style-guide";
import { DecimalChecker } from "../Utility/DecimalChecker";

class ExchangeInput extends DecimalChecker {
  constructor() {
    super();
  }

  UNSAFE_componentWillReceiveProps(np) {
    if (this.props.value && !np.value) {
      this.refs.input.value = "";
    }
  }

  render() {
    // allowNaN is no valid prop for Input, remove
    var {
      allowNaN,
      ...other
    } = this.props;
    return /*#__PURE__*/React.createElement(Input, _extends({
      ref: "input",
      type: "text"
    }, other, {
      onPaste: this.props.onPaste || this.onPaste.bind(this),
      onKeyPress: this.onKeyPress.bind(this)
    }));
  }

}

export default ExchangeInput;